import { z } from 'zod';

const schema = z.object({
  VITE_API_URL: z.string().min(1, 'VITE_API_URL is required'),
});

const parsed = schema.safeParse(import.meta.env);

if (!parsed.success) {
  const lines = parsed.error.issues
    .map((i) => `  ${i.path.join('.')}: ${i.message}`)
    .join('\n');
  throw new Error(`Invalid environment variables:\n${lines}`);
}

export const env = parsed.data;
